import { DEFAULT_TASK_FIELD_COLOR } from "@jugl-web/domain-resources/custom-fields/consts";
import { TaskDefaultStatusId } from "@jugl-web/rest-api/tasks";
import { TaskCustomStatusModel } from "@jugl-web/rest-api/tasks/models/TaskCustomStatus";
import {
  DEFAULT_COMPLETED_STATUS_COLOR,
  DEFAULT_PENDING_STATUS_COLOR,
} from "../consts";

export const getStatusColor = (status: TaskCustomStatusModel) => {
  if (status.id === TaskDefaultStatusId.pending) {
    return status.color || DEFAULT_PENDING_STATUS_COLOR;
  }

  if (status.id === TaskDefaultStatusId.completed) {
    return status.color || DEFAULT_COMPLETED_STATUS_COLOR;
  }

  return status.color || DEFAULT_TASK_FIELD_COLOR;
};
